import { useLocalStorage } from "@mantine/hooks"

export const useCurrentBusiness = (): [string, (val: string | ((prevState: string) => string)) => void, () => void] => {
    const [value, setValue, remove] = useLocalStorage({ key: 'currentBusiness', defaultValue: 'none' });
    return [value || "", setValue, remove]
}